
<template>
  <div>
    <b-button v-b-modal.filter-modal variant="primary" size="sm">Geavanceerde Filters</b-button>

    <b-modal id="filter-modal" size="lg" hide-footer title="Geavanceerde Filters" :key="productSettings[799].supplier">

      <div class="mt-0">Filters</div>
      <div class="row mx-2 small">
        <div class="col">
          <input type="checkbox" class="form-check-input" style="height: 18px" v-model="filter.inStock"/>
          <label class="text-muted">Voorraad > 0</label>
        </div>
        <div class="col">
          <input type="checkbox" class="form-check-input" style="height: 18px" v-model="filter.outOfStock"/>
          <label class="text-muted">Geen Voorraad</label>
        </div>
        <div class="col">
          <input type="checkbox" class="form-check-input" style="height: 18px" v-model="filter.sell7d"/>
          <label class="text-muted">7d verkoop > 0</label>
        </div>
        <div class="col">
          <input type="checkbox" class="form-check-input" style="height: 18px" v-model="filter.sell1M"/>
          <label class="text-muted">1M verkoop > 0</label>
        </div>
        <div class="col">
          <input type="checkbox" class="form-check-input" style="height: 18px" v-model="filter.sell1Y"/>
          <label class="text-muted">1Y verkoop > 0</label>
        </div>
      </div>
      <div class="row mx-2 small">
        <div class="col">
          <input type="checkbox" class="form-check-input" style="height: 18px" v-model="filter.brandEmpty"/>
          <label class="text-muted">Merk Leeg</label>
        </div>
        <div class="col">
          <input type="checkbox" class="form-check-input" style="height: 18px" v-model="filter.supplierEmpty"/>
          <label class="text-muted">Leverancier Leeg</label>
        </div>
        <div class="col">
          <input type="checkbox" class="form-check-input" style="height: 18px" v-model="filter.stopped"/>
          <label class="text-muted">Stop bijbestellen</label>
        </div>
        <div class="col">
          <input type="checkbox" class="form-check-input" style="height: 18px" v-model="filter.noEngine"/>
          <label class="text-muted">Geen Engine advies</label>
        </div>
        <div class="col">
          <input type="checkbox" class="form-check-input" style="height: 18px" v-model="filter.orderZero"/>
          <label class="text-muted">Bestellen = 0</label>
        </div>
      </div>


      <hr/>
      <div class="mt-0">Product Categorie Filter</div>

      <div v-for="category in new Set(products.map((p) => p.category))" class="badge clickable" @click="toggleCategory(category)" :class="{'badge-success': isCategorySelected(category) }">{{category}}</div>

      <hr/>

      <div class="mt-0">Product Merk Filter</div>

      <div v-for="brand in new Set(products.map((p) => p.brand))" class="badge clickable" @click="toggleBrand(brand)" :class="{'badge-success': isBrandSelected(brand) }">{{brand}}</div>

      <hr/>
      <div class="mt-0">Leverancier Filter</div>

      <div v-for="leverancier in new Set(products.map((p) => productSettings[p.id] ? productSettings[p.id].supplier: ''))" class="badge clickable" @click="toggleLeverancier(leverancier)" :class="{'badge-success': isLeverancierSelected(leverancier) }">{{leverancier}}</div>


    </b-modal>
  </div>
</template>

<script>

  export default {
    props: {
      products: Array,
      productSettings: Object,
      filter: Object,
    },
    data () {
      return {
      }
    },
    mounted() {
    },
    methods: {
      isCategorySelected(category) {
        return this.filter.category.indexOf(category) !== -1
      },
      toggleCategory(category) {
        if (this.isCategorySelected(category)) {
          this.filter.category = this.filter.category.filter((c) => c !== category);
        } else {
          this.filter.category.push(category);
        }
        this.$forceUpdate()
      },
      isBrandSelected(brand) {
        return this.filter.brand.indexOf(brand) !== -1
      },
      toggleBrand(brand) {
        if (this.isBrandSelected(brand)) {
          this.filter.brand = this.filter.brand.filter((c) => c !== brand);
        } else {
          this.filter.brand.push(brand);
        }
        this.$forceUpdate()
      },
      isLeverancierSelected(leverancier) {
        return this.filter.leverancier.indexOf(leverancier) !== -1
      },
      toggleLeverancier(leverancier) {
        if (this.isLeverancierSelected(leverancier)) {
          this.filter.leverancier = this.filter.leverancier.filter((c) => c !== leverancier);
        } else {
          this.filter.leverancier.push(leverancier);
        }
        this.$forceUpdate()
      }
    }
  }
</script>

<style>
  .clickable:hover {
    cursor: pointer !important;
  }
</style>
